import { Module } from 'vuex';

export interface ListCollectionStore {
  listSelectedGroup: [];
  listSelectedDocument: [];
  listBookmarkFeed: [];
}
export const listCollection: Module<ListCollectionStore, any> = {
  namespaced: true,
  state: {
    listSelectedGroup: [],
    listSelectedDocument: [],
    listBookmarkFeed: [],
  },
  getters: {
    getListSelectedGroup: state => state.listSelectedGroup,
    getListSelectedDocument: state => state.listSelectedDocument,
    getListBookmarkFeed: state => state.listBookmarkFeed,
  },
  mutations: {
    setListSelectedGroup(state, listSelectedGroup) {
      state.listSelectedGroup = listSelectedGroup;
    },
    setListSelectedDocument(state, listSelectedDocument) {
      state.listSelectedDocument = listSelectedDocument;
    },
    setListBookmarkFeed(state, listBookmarkFeed) {
      state.listBookmarkFeed = listBookmarkFeed;
    },
  },
  actions: {
    changeListSelectedGroup(context, payload: { listSelectedGroup: [] }) {
      context.commit('setListSelectedGroup', payload.listSelectedGroup);
    },
    changeListSelectedDocument(context, payload: { listSelectedDocument: [] }) {
      context.commit('setListSelectedDocument', payload.listSelectedDocument);
    },
    changeListBookmarkFeed(context, payload: { listBookmarkFeed: [] }) {
      context.commit('setListBookmarkFeed', payload.listBookmarkFeed);
    },
  },
};
